/**
 * Returns `true` if `x` is less than or equal to `y`.
 *
 * @param {number|string} x
 * @param {number|string} y
 * @returns {boolean}
 */
export function lte(x, y) {
  return Number(x) <= Number(y);
}
